import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { auth } from '../../../firebase';
import { v4 as uuidv4 } from 'uuid';

const getConversationById = (conversationId, callback) => {
  return async (dispatch) => {
    dispatch({ type: 'FETCHING_CONVERSATION_BY_ID' });
    try {
      let unsubscribe = onAuthStateChanged(auth, async (user) => {
        const token = await user?.getIdToken();
        const userInfo = localStorage.getItem('userInfo');
        const userId = JSON.parse(userInfo)?.id;
        const reqId = uuidv4();
        try {
          const response = await axios.get(
            `/cs/conversation/${conversationId}`,
            {
              params: {
                'request-id': reqId,
              },
              headers: {
                Authorization: `Bearer ${token}`,
                // 'x-api-version': 'v2',
              },
            },
          );
          if (response.status === 200) {
            await dispatch({
              type: 'FETCHING_CONVERSATION_BY_ID_DONE',
              payload: {
                conversations: response?.data,
              },
            });
            if (typeof callback === 'function') {
              callback(response?.data);
            }
          } else {
            dispatch({
              type: 'FETCHING_CONVERSATION_BY_ID_FAILED',
              payload: `Failed to get conversation by id`,
            });
          }
        } catch (e) {
          dispatch({
            type: 'FETCHING_CONVERSATION_BY_ID_FAILED',
            payload: `Failed to get conversation by id`,
          });
        }
        unsubscribe();
      });
    } catch (e) {
      dispatch({
        type: 'FETCHING_CONVERSATION_BY_ID_FAILED',
        payload: `Failed to get conversation by id`,
      });
    }
  };
};

export default getConversationById;
